import { Button, Form } from 'antd';
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Assets } from '../../assets';
import { MYCInput } from '../../components/input_form.component';
import { UserContext } from '../../App';
import { sendPasswordResetEmail, signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase/firebaseApp';
import { toast } from 'react-toastify';
import { Constants, PortalVersions } from '../../constants/general.constant';
import { getAuthenticatedUserProfile } from '../../firebase/userProfile';

export const SignInScreen = () => {
    const navigate = useNavigate();
    const { setUser } = useContext(UserContext);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [resettingPassword, setResettingPassword] = useState(false);
    const isAdminPortal = process.env.REACT_APP_MODE === Constants.ADMIN;
    const versionLabel = isAdminPortal ? `Version ${PortalVersions.ADMIN}` : `Client portal ${PortalVersions.CLIENT}`;

    const _onFinish = async values => {
        setLoading(true);
        try {
            const credential = await signInWithEmailAndPassword(
                auth,
                values?.Email,
                values?.Password
            );
            const profile = await getAuthenticatedUserProfile(credential.user.uid);
            setUser(profile || {
                id: credential.user.uid,
                uid: credential.user.uid,
                email: credential.user.email,
                name: credential.user.displayName || credential.user.email,
            });
            navigate("/", { replace: true });
        
        } catch(e) {
            console.error("[LOGIN] Error",e);
            const code = e?.code || "auth/unknown";
            const message = code === "auth/invalid-credential"
                ? "Login failed: invalid email or password"
                : `Login failed: ${code}`;
            toast.error(message);
        } finally {
            setLoading(false);
        }
    }

    const _onResetPassword = async () => {
        const email = form.getFieldValue("Email");
        if (!email) {
            toast.error("Enter your email address first");
            return;
        }

        setResettingPassword(true);
        try {
            await sendPasswordResetEmail(auth, email);
            toast.success("Password reset email sent");
        } catch (e) {
            console.error("[LOGIN] Password reset error", e);
            toast.error(`Password reset failed: ${e?.code || "auth/unknown"}`);
        } finally {
            setResettingPassword(false);
        }
    };

    return <div className='flex flex-col justify-center items-center px-6' style={{ minHeight: '100vh', width: '100vw', backgroundImage: `url(${Assets.LoginBG})`, backgroundSize: 'cover' }}>
        <div className='flex flex-1 flex-col gap-5 justify-center items-center'>
            <img src={Assets.Logo} className="object-contain w-52 h-32" alt="" />
            <div className='text-white bg-primary-orange px-12 py-3'>
                Welcome To Your <span className='text-black'>Portal</span>
            </div>
            <span className='text-white'>
                Safe, trust worthy and money saving driver services.
            </span>
            <div className='w-64 flex flex-row gap-5'>
                <Form form={form} onFinish={_onFinish} className="w-full text-white flex flex-col" layout="vertical">
                    <MYCInput name="Email" labelColor="white" label="Email" required noMb />
                    <MYCInput name="Password" label="Password" labelColor="white" type="password" noMb required />
                    <Button loading={loading} htmlType="submit" type="primary">Sign In</Button>
                    <Button
                        className="mt-2 text-white"
                        disabled={loading}
                        loading={resettingPassword}
                        onClick={_onResetPassword}
                        type="link"
                    >
                        Reset password
                    </Button>
                </Form>
            </div>
        </div>
        <div className='pb-6 text-sm font-medium text-white/90'>
            {versionLabel}
        </div>
    </div>
}
